import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authenticationGuard: CanActivateFn = () => {
  // const oAuthService = inject(OAuthService);
  // return oAuthService.hasValidAccessToken();
  return true;
};
